import { Box, Button, Divider, Typography } from "@mui/material";
import { formatCurrency } from "@helpers/funciones";
import { MotorbikeCatalogItem } from "@interfaces/catalogs";

export interface CardInformacionMotoProps {
  item: MotorbikeCatalogItem;
  onSelect: (item: MotorbikeCatalogItem) => void;
  size: "small" | "large";
  disabled?: boolean;
  isSelected?: boolean;
}

const DEFAULT_IMAGE_PATH =
  "https://www.shutterstock.com/image-vector/default-ui-image-placeholder-wireframes-600nw-1037719192.jpg";

const CardInformacionMoto = ({ item, onSelect, size, disabled, isSelected }: CardInformacionMotoProps) => {

  const down_payment_amount = ((item.data?.price || 0) * (item.data?.down_payment || 0)) / 100;

  return (
    <Box
      sx={{
        width: size === "small" ? "220px" : "292px",
        minHeight: "350px",
        height: "400px",
        border: "1px solid",
        borderColor: "#BDD1F4",
        borderRadius: "16px",
        p: size === "small" ? 2 : 3,
        bgcolor: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Box
          component="img"
          src={item.image_path || DEFAULT_IMAGE_PATH}
          alt={item.name}
          sx={{
            width: "100%",
            maxWidth: 210,
            height: 120,
            objectFit: "contain",
          }}
          onError={(e) => {
            e.currentTarget.src = DEFAULT_IMAGE_PATH;
          }}
        />

        <Typography
          variant={size === "small" ? "body1" : "h5"}
          fontWeight={700}
          color="primary.light"
          textAlign="center"
          sx={{ mt: 1 }}
        >
          {item.name || "NA"}
        </Typography>

        <Typography
          variant={size === "small" ? "h4" : "h3"}
          color="primary.dark"
          fontWeight={700}
          textAlign="center"
          sx={{ mt: 1 }}
        >
          {formatCurrency(item.data?.price || 0)} MXN
        </Typography>

        <Divider sx={{ width: "100%", my: 1, color: "primary.dark" }} />

        <Typography
          variant={size === "small" ? "body2" : "body1"}
          color="primary.light"
          textAlign="center"
          fontWeight={400}
        >
          Enganche
        </Typography>

        <Typography variant={size === "small" ? "h5" : "h4"} color="primary.dark" fontWeight={600} textAlign="center">
          {formatCurrency(down_payment_amount)} MXN
        </Typography>

        <Divider sx={{ width: "100%", my: 1, color: "primary.dark" }} />

        <Typography
          variant={size === "small" ? "body2" : "body1"}
          color="primary.light"
          textAlign="center"
          fontWeight={400}
        >
          Pago diario
        </Typography>

        <Typography variant={size === "small" ? "h5" : "h4"} color="primary.dark" fontWeight={700} textAlign="center">
          {formatCurrency(item.data?.daily_payment || 0)} MXN
        </Typography>
      </Box>

      <Button
        variant="default"
        size="medium"
        onClick={() => onSelect(item)}
        disabled={disabled || isSelected}
        sx={{
          mt: 2,
          minWidth: 140,
          height: 42,
        }}
      >
        {isSelected ? "Seleccionado" : "Seleccionar"}
      </Button>
    </Box>
  );
};

export default CardInformacionMoto;
